export default "__VITE_ASSET__466c20f1__"